import _slicedToArray from "/codebuild/output/src3426499911/src/development-activity-model/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import { useState, useRef, useEffect } from 'react'; // See also: https://overreacted.io/making-setinterval-declarative-with-react-hooks/

/**
 *
 * useInterval hook
 *
 * Declaratively creates a setInterval to run a callback after a fixed
 * amount of time
 *
 *@param {funnction} callback - Callback to be fired
 *@param {number} intervalId - Interval duration in milliseconds after which the callback is to be fired
 *@param {boolean} startImmediate - Whether the interval should start immediately on initialise
 *@return {IntervalHandler}
 */

function useInterval(callback, intervalDuration) {
  var startImmediate = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  var _useState = useState(null),
      _useState2 = _slicedToArray(_useState, 2),
      intervalId = _useState2[0],
      setIntervalId = _useState2[1];

  var _useState3 = useState(startImmediate),
      _useState4 = _slicedToArray(_useState3, 2),
      isRunning = _useState4[0],
      setIsRunning = _useState4[1];

  var savedCallback = useRef();

  function start() {
    if (!isRunning) {
      setIsRunning(true);
    }
  }

  function stop() {
    if (isRunning) {
      setIsRunning(false);
    }
  } // Remember the latest callback.


  useEffect(function () {
    savedCallback.current = callback;
  }); // Set up the interval.

  useEffect(function () {
    function tick() {
      savedCallback.current && savedCallback.current();
    }

    if (intervalDuration !== null && isRunning) {
      var id = setInterval(tick, intervalDuration);
      setIntervalId(id);
      return function () {
        return clearInterval(id);
      };
    }
  }, [intervalDuration, isRunning]);
  var handler;
  handler = [start, stop, intervalId];
  handler.start = start;
  handler.stop = stop;
  handler.intervalId = intervalId;
  return handler;
}

export default useInterval;